import styled, { keyframes } from 'styled-components';
import { scaleDownCenter } from '../../constants/animations';
import { TinyText } from '../texts';
import { ROUND_SCALE_BUTTON_SIZING, BUTTON_FILL_COLORS } from './constants';

const appearTextAnimation = keyframes`
  0% {opacity: 0;}
  70% {opacity: .9;}
  100% {opacity: 1;}
`;

export const RoundScaleButtonStyle = styled.button<any>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: ${props =>
    props.diameter
      ? props.diameter
      : props.size
        ? ROUND_SCALE_BUTTON_SIZING[props.size]
        : ROUND_SCALE_BUTTON_SIZING.m}px;
  height: ${props =>
    props.diameter
      ? props.diameter
      : props.size
        ? ROUND_SCALE_BUTTON_SIZING[props.size]
        : ROUND_SCALE_BUTTON_SIZING.m}px;
  background-color: initial;
  border-radius: 50%;
  transition: all ${p => p.theme.duration.m} cubic-bezier(0.215, 0.61, 0.355, 1);
  animation: ${p => (p.animate ? scaleDownCenter : 'none')}
    ${p => p.theme.duration.m} ease forwards;

  &::before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    box-shadow: ${p => (p.big ? p.theme.shadow.xl : p.theme.shadow.l)};
    transform: scale(0.75);
    transition: transform ${p => p.theme.duration.m}
      cubic-bezier(0.215, 0.61, 0.355, 1);
    z-index: -1;
    background-color: ${props =>
    props.backgroundColor
      ? props.theme.color[props.backgroundColor]
      : props.theme.color[BUTTON_FILL_COLORS[props.mood]] ||
      props.theme.color.backgroundRush};
  }

  &:hover,
  &:active {
    box-shadow: ${props => props.theme.shadow.xl};
    &::before {
      transform: scale(1);
    }
  }
`;

export const RoundScaleIcon = styled.div<any>`
  height: 20px;

  span {
    height: 20px;
  }

  svg {
    width: 20px;
    transition: ${p => p.theme.duration.m} ${p => p.theme.function.oq};
    height: 20px;
    fill: ${p => p.theme.color[p.fill] || p.theme.color.white};
  }
  ${RoundScaleButtonStyle}:hover & {
    svg {
      transform: translateY(${p => (p.big ? -15 : -10)}px);
    }
  }
`;

export const RoundScaleText = styled(TinyText)<any>`
  text-transform: uppercase;
  opacity: 0;
  visibility: hidden;
  transition: ${p => p.theme.duration.m} ${p => p.theme.function.oq};
  animation: ${appearTextAnimation} ${p => p.theme.duration.m};
  position: absolute;

  ${RoundScaleButtonStyle}:hover & {
    opacity: 1;
    visibility: visible;
    transform: translateY(15px);
  }
`;
